import React from 'react';
import { FormControl, FormLabel, FormHelperText, Paper, useForkRef, Typography, TextField, IconButton, InputAdornment, Button } from '@material-ui/core';
import Signature from '../Signature';
import _, { omit, pick, round, slice } from 'lodash';
import PF from "../_Services/publicFunction";
import Qs from "qs";
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../reducers/app";
import useSound from 'use-sound';
import switchlight from '../sounds/switchlight.wav';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';
import { useSnackbar } from "notistack";
import { indigo, teal, deepPurple } from '@material-ui/core/colors'

const domToImage = require('dom-to-image');

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },

    half_background: {
        background: "linear-gradient(to top, yellow 50%, transparent 50%)"
    },
}));

const NoPaper = props => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const initialRender = React.useRef(true);
    const intl = useIntl();
    const { setActiveStep } = props;
    const { dark } = useSelector(state => ({
        dark: state.app.dark,
    }));
    const { UserInfo } = useSelector(state => ({
        UserInfo: state.app.UserInfo,
    }));
    const [imageURL, setImage] = React.useState(null);  //提交=>簽名檔img
    const [timestamp, setTime] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [user, setUser] = React.useState({
        email: UserInfo.Email,
        personalId: UserInfo.PersonalId,
        UserName: UserInfo.UserName,
    })
    const [settingObj, setObj] = React.useState({
        UserName: { label: "姓名", name: "UserName", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, minLength: 2, maxLength: 30, pattern: "^[^0-9]+$" },
        email: { label: "出生日期", name: "email", type: "email", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12 },
        personalId: { label: "身分證字號", name: "personalId", type: "text", required: true, helperText: "required", xs: 12, sm: 12, md: 12, lg: 12, minLength: 10, maxLength: 10 }
    })
    const [playActive] = useSound(
        switchlight,
        { volume: 0.5 }
    );
    const handleLogOut = () => {
        const { history } = props
        // setTimeout(() => {
        //     sessionStorage.removeItem('token');
        //     history.push("LOGIN")
        // }, 5400);


    };
    const handleSubmit = e => {
        e.preventDefault();
        if (validator()) {
            //清除
            // handleNext("",66);
            PF.instance({
                method: "post",
                url: PF.url + "/Nopaper/getdata",
                data: Qs.stringify({ parameter: user }),
            })
                .then(function (response) {
                    const { TotalRecord, rows, token, UserInfo } = response.data;
                    if (TotalRecord > 0) {
                        if (rows[0].NoPaperId === null) {
                            // console.log("繼續簽名")
                            // setOpen(true);
                            // setUser(prevstate => ({
                            //     ...prevstate,
                            //     BarcodeStr: rows[0]
                            // }));
                            // console.log(rows[0]);
                            let newitem = _.merge(user, rows[0]);
                            updateUser(newitem)
                            setImage("OK");
                            setActiveStep((prevActiveStep) => prevActiveStep + 1);

                        } else {
                            // alert("之前已確認使用無紙化服務，感謝與您一同保護地球！");
                            alert(intl.formatMessage({ id: "app.NopaperComfirm" }))
                        }
                    } else {
                        // alert("查無客戶資料，請確認")
                        alert(intl.formatMessage({ id: "app.NopaperNoexit" }))
                    }

                })
        }
    }
    const { enqueueSnackbar } = useSnackbar();

    const updateUser = (prop) => {
        // const {user,...rest}=prop
        //u.BarcodeStr = prop;
        PF.instance({
            method: "post",
            url: PF.url + "/Nopaper/Update",
            data: Qs.stringify({ parameter: prop }),
        })
            .then(function (response) {
                const { TotalRecord, rows, token, UserInfo } = response.data;
                console.log(response.data);
                if (TotalRecord <= 0) {
                    enqueueSnackbar(intl.formatMessage({ id: "update fail" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
                } else {
                    enqueueSnackbar(intl.formatMessage({ id: "update success" }), { variant: "success", style: { whiteSpace: 'pre-line' } });
                }
                // alert("感謝與您一同保護地球！")
            })

    }
    React.useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {

            var element = document.getElementById('signature');
            // var options = {
            //   filename:  sessionStorage.getItem('BarCodeStr')  + '.pdf',
            // };
            // var pdf = new jsPDF();

            domToImage.toBlob(element).then((blob) => {
                // var image = canvas.toDataURL("image/png");
                // pdf.addImage(image, 'JPEG', 0, 0);
                // document.body.appendChild(image)
                // var pdf2 = pdf.output('blob');
                let data = new FormData();
                data.append('files', blob, user.personalId + "-" + new Date().toISOString().split('T')[0] + '.png')
                PF.instance({
                    method: "post",
                    url: PF.url + "/Questionaire/Upload",
                    data: data,
                    headers: { token: sessionStorage.token }
                })
                    .then(function (response) {
                        // alert("完成")
                        //console.log(response.data)
                    })

            })
            handleLogOut();
        }
    }, [imageURL]); //避免循環

    const validator = () => {
        const form = formRef.current; //參數1

        if (form.checkValidity()) {
            console.log("全部通過");
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (Object.keys(settingObj).includes(element.name)) {
                    setObj(prevState => ({
                        ...prevState,
                        [element.name]: omit(prevState[element.name], ["error"])
                    }))
                }
            }
            return true;
        } else {
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
                    if (Object.keys(settingObj).includes(element.name)) {
                        setObj(prevState => ({
                            ...prevState,
                            [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
                        }))
                    }

                } else {//驗證通過，自訂訊息
                    //有在settingObj的
                    if (Object.keys(settingObj).includes(element.name)) {
                        setObj(prevState => ({
                            ...prevState,
                            [element.name]: omit(prevState[element.name], ["error"])
                        }))
                    }

                }
            }
            return false;
        }
    }

    const handleTxtChange = e => {
        if (_.isNil(imageURL)) {
            const { name, value } = e.target;
            setUser(prevstate => ({
                ...prevstate,
                [name]: value.trim()
            }));
        }

    }
    const formRef = React.createRef();
    const handleClear = () => {
        if (_.isNil(imageURL)) {

            setUser(prevstate => ({
                ...prevstate,
                email: ""
            }));
        }

    }

    return <Paper elevation={3} style={{ margin: "10px", padding: "20px" }}>
        <DarkModeSwitch
            style={{ marginBottom: '2rem', float: "right" }}
            checked={dark}
            onChange={() => dispatch(actions.THEME_SET({ theme: !dark }))}
            onMouseDown={() => playActive()}
            size={20} />
        <Typography variant="h5" gutterBottom style={{ textAlign: "center", fontWeight: "bold", textDecoration: "underline" }}><FormattedMessage id={"健檢報告完成通知信箱確認"} /></Typography>

        <form ref={formRef}>
            <Typography>
                <TextField
                    name={"UserName"}
                    required={true}
                    // onChange={handleTxtChange}   //代入的訊息不能修改
                    autoComplete="off"
                    value={user.UserName || ""}
                    helperText={settingObj.UserName.error ? settingObj.UserName.helperText : null}
                    error={settingObj.UserName.error || false}
                    inputProps={{ minLength: 2, maxLength: 30, pattern: "^[^0-9]+$" }}
                />
                <span><FormattedMessage id={" 晨悅診所將本人健康檢查報告，"} /><mark><FormattedMessage id={"完成後以email方式通知至本人確認電子信箱"} /></mark><FormattedMessage id={"，資料如下"} /></span></Typography>
            <br />
            <Typography><span><FormattedMessage id={"立書同意人："} /></span></Typography>

            <Typography>
                <span><FormattedMessage id={"身分證字號："} /></span>
                <TextField
                    name={"personalId"}
                    required={true}
                    // onChange={handleTxtChange}   //代入的訊息不能修改
                    autoComplete="off"
                    value={user.personalId || ""}
                    helperText={settingObj.personalId.error ? settingObj.personalId.helperText : null}
                    error={settingObj.personalId.error || false}
                    inputProps={{ minLength: 10, maxLength: 10 }}
                />
            </Typography>
            <Typography>
                <span><FormattedMessage id={"E-mail:   (用於通知報告完成，請您確認正確)"} /></span>
                <TextField
                    name={"email"}
                    required={true}
                    onChange={handleTxtChange}
                    value={user.email || ""}
                    fullWidth
                    autoComplete="off"
                    helperText={settingObj.email.error ? settingObj.email.helperText : null}
                    error={settingObj.email.error || false}
                    inputProps={{ type: "email" }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton onClick={handleClear}>
                                <CancelIcon />
                            </IconButton>
                        </InputAdornment>,
                    }}
                />
            </Typography>
        </form>
        <br />
        {_.isNil(imageURL) ? (
            <>
                <Button variant="contained" color="primary" onClick={handleSubmit} style={{ backgroundColor: teal[700] }}><FormattedMessage id={"Email確認正確"} /></Button>
                <Typography style={{ color: "red", fontWeight: "bold" }}><FormattedMessage id={"點擊按鈕才算完成"} /></Typography>

            </>
        ) : <Typography variant="h6" style={{ fontWeight: "bold", color: indigo[700] }}><FormattedMessage id={"謝謝"} /></Typography>
        }
        {/* <Signature setImage={setImage} imageURL={imageURL} setTime={setTime} open={open} setOpen={setOpen} handleSubmit={handleSubmit} />
        {imageURL ?
            (<Typography id={"signature"} style={{ paddingTop: "100px" }}>
                <div style={{ textAlign: "lefts" }} >
                    <img
                        src={imageURL}
                        alt="my signature"
                        align="center"
                        style={{
                            // display: "block",
                            margin: "0 auto",
                            borderBottom: "1px solid black",
                            width: "250px",
                            paddingLeft: "30px", //讓簽名更像
                            paddingRight: "30px",//讓簽名更像
                        }}
                    />
                </div>
                <div>
                    <label><FormattedMessage id={"簽名時間："} />{timestamp}</label>
                </div>
            </Typography>
            )
            : null
        } */}
    </Paper>
}


export default NoPaper